import FileInput from './FileInput'
import BurgerMenu from './BurgerMenu';

const User = () => (
	<div className="userContainer" style={{display: "block"}}>
		<BurgerMenu />
		<FileInput />
	</div>
)

export default User